import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/app-modals';
import popupPageModeMixin from '@/mixins/popupPageModeMixin';

export default {
  mixins: [
    popupPageModeMixin,
  ],
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    onCreateAccount() {
      if (this.isPage) {
        this.$router.push({ name: 'account-page-register' });
      } else {
        this.setCurrentPopup(MODALS.REGISTER);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-login/footer/footer.js